module.exports = __webpack_public_path__ + "media/assets/images/column-thumbnail_fire-bf026202af0a3fd2a00a53895a348bde.png";